import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SectionSelectionsQuery } from '../section_selections/queries/section_selections_query';
import {
  SelectedSectionActionsFacade,
  TMultiSelectMode
} from '../../views/course_scheduler/facades/selected_section_actions_facade';
import { SchedulerActiveTermQuery } from '../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import { SectionInfoServant } from '../../views/sections/servants/section_info_servant';
import { ISection } from '../../interfaces/scheduler_interfaces';
import { RequestStateQuery } from '../../request_state/queries/request_state_query';

class SelectedSectionActionsModal {
  private opened: boolean = false;
  private headerText: string;
  private descriptionText = '';
  private buttonText: string;
  private mode: TMultiSelectMode;
  private withdrawConfirmationText: string = '';
  private openDropModeBound: () => void;
  private openWithdrawModeBound: () => void;
  private openWaitlistModeBound: () => void;
  private closeBound: () => void;

  constructor(
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade,
    private ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
    private ngSectionInfoServant: SectionInfoServant,
    private ngRequestStateQuery: RequestStateQuery
  ) {}

  $onInit() {
    this.withdrawConfirmationText = this.ngSelectedSectionActionsFacade.getWithdrawText();
    this.closeBound = this.closeDialog.bind(this);
    this.openDropModeBound = this.openDropModeDialog.bind(this);
    this.openWithdrawModeBound = this.openWithdrawModeDialog.bind(this);
    this.openWaitlistModeBound = this.openWaitlistModeDialog.bind(this);

    this.ngComponentCommunicatorService.subscribe('OPEN_MULTI_DROP_MODAL', this.openDropModeBound);
    this.ngComponentCommunicatorService.subscribe('OPEN_MULTI_WITHDRAW_MODAL', this.openWithdrawModeBound);
    this.ngComponentCommunicatorService.subscribe('OPEN_MULTI_WAITLIST_MODAL', this.openWaitlistModeBound);
    this.ngComponentCommunicatorService.subscribe('CLOSE_MULTI_SECTION_ACTIONS_MODAL', this.closeBound);
  }

  openDropModeDialog() {
    const dropText = 'Drop Course(s)';
    this.mode = 'drop';
    this.headerText = dropText;
    this.descriptionText = `Are you sure you want to ${this.mode} ${this.getSelectionCount()} course(s) from ${
      this.ngSchedulerActiveTermQuery.result.name
    }?`;
    this.buttonText = dropText;
    this.openDialog();
  }

  openWithdrawModeDialog() {
    this.mode = 'withdraw';
    this.headerText = 'Withdraw Course(s)';
    this.descriptionText = `Are you sure you want to ${this.mode} ${this.getSelectionCount()} course(s) from ${
      this.ngSchedulerActiveTermQuery.result.name
    }?`;
    this.buttonText = 'Withdraw from Course(s)';
    this.openDialog();
  }

  openWaitlistModeDialog() {
    const waitlistText = 'Waitlist Course(s)';
    this.mode = 'waitlist';
    this.headerText = waitlistText;
    this.descriptionText = `Are you sure you want to ${this.mode} ${this.getSelectionCount()} course(s) in ${
      this.ngSchedulerActiveTermQuery.result.name
    }?`;
    this.buttonText = waitlistText;
    this.openDialog();
  }

  openDialog() {
    this.opened = true;
  }

  closeDialog() {
    this.opened = false;
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release('OPEN_MULTI_DROP_MODAL', this.openDropModeBound);
    this.ngComponentCommunicatorService.release('OPEN_MULTI_WITHDRAW_MODAL', this.openWithdrawModeBound);
    this.ngComponentCommunicatorService.release('OPEN_MULTI_WAITLIST_MODAL', this.openWaitlistModeDialog);
    this.ngComponentCommunicatorService.release('CLOSE_MULTI_SECTION_ACTIONS_MODAL', this.closeBound);
  }

  getSelectionCount() {
    return this.ngSelectedSectionActionsFacade.getSelectionCountByMode(this.mode);
  }

  getSelectedSectionsInfo() {
    return this.ngSelectedSectionActionsFacade.getSectionsInfoByMode(this.mode);
  }

  getSectionLabel(section: ISection) {
    return this.ngSectionInfoServant.getSectionLabel(section);
  }

  onSubmitTriggerEnded() {
    this.ngSelectedSectionActionsFacade.invokeMultiSectionsAction(this.mode);
    this.closeDialog();
  }
}

angular.module('capability-ng-scheduler').component('selectedSectionActionsModal', {
  templateUrl:
    'capability-ng-scheduler/src/components/selected_section_actions_modal/selected_section_actions_modal.html',
  bindings: {},
  controller: SelectedSectionActionsModal
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/selected_section_actions_modal/selected_section_actions_modal.ts